import React, { useState } from 'react';
import RichHtmlFrame from './RichHtmlFrame';

export const BONUS_CARD_HTML_MAX_HEIGHT = 240;

// Kampanya kartında HTML açıklamanın tasarımıyla çizilmiş, kırpılmış hâli
// (panelde "Kartta da tasarımıyla göster" açıkken). Şablon kendi sandbox
// çerçevesinde çizilir (bkz. lib/richHtmlFrame.js); kart yalnızca yüksekliği
// sınırlar. Taşan içerikte alt kenar soldurulur ve kartın tamamı detay
// penceresini açan bir düğme olur — çerçevenin içindeki akordeonlar kartta
// değil pencerede kullanılır.
const BonusCardHtml = ({
  html, title = 'Kampanya açıklaması', onOpen,
  maxHeight = BONUS_CARD_HTML_MAX_HEIGHT, fadeColor = 'var(--pusu-card-4, #111)',
  className = '',
}) => {
  const [overflowing, setOverflowing] = useState(false);
  if (!html || !html.trim()) return null;
  return (
    <div
      className={`relative overflow-hidden rounded-lg ${className}`}
      style={{ maxHeight }}
      data-testid="bonus-card-html"
    >
      <RichHtmlFrame
        html={html}
        title={title}
        onHeight={(height) => setOverflowing(height > maxHeight)}
      />
      {overflowing && (
        <div
          aria-hidden="true"
          className="pointer-events-none absolute inset-x-0 bottom-0 h-16"
          style={{ background: `linear-gradient(180deg, transparent 0%, ${fadeColor} 100%)` }}
        />
      )}
      {onOpen && (
        <button
          type="button"
          onClick={onOpen}
          aria-label={`${title} — detayı aç`}
          className="absolute inset-0 h-full w-full cursor-pointer bg-transparent"
        />
      )}
    </div>
  );
};

export default BonusCardHtml;
